module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"map_button":"Map","request":{"josm_failed":"Failed to load data into JOSM. See the FAQ for more information."}},"ko":{"map_button":"매핑","request":{"josm_failed":null}}}')
  delete Component.options._Ctor
}
